import { useSelector } from 'react-redux';

export default function useShowHideSectionHooks(productInfoObj) {
  const { productCostingstate, internalState } = productInfoObj;

  const {
    UserDetails: { userRole },
    MultiProductSelectReducer: { isProductArchived },
  } = useSelector((prevState) => prevState);

  const {
    productInfo: { supplierId },
  } = productCostingstate;
  const isSupplier = userRole === 'Supplier';
  const onLoadDisable = !supplierId;
  const isDisabled = isProductArchived || internalState?.markAsComplete || userRole === 'Supplier';

  const { hideLengthCol } = internalState;
  const { hideColourCol } = internalState;

  return {
    isSupplier,
    onLoadDisable,
    isDisabled,
    hideLengthCol,
    hideColourCol,
  };
}
